import React from 'react';
import { Button } from '@blueprintjs/core';
export function SlateButton(props) {
    return (React.createElement(Button, Object.assign({ outlined: true, intent: 'slate', icon: props.icon || null }, props), props.children || ''));
}
